import React, { Component } from 'react';
import Global from '../../Global';
import NavMobile from './NavMobile';
import OldSearch from './OldSearch';

class Nav extends Component {

  constructor( props ) {
    super(props);

    this.state = {
      topNav: {},
      topNavBody:[],
      topNavActive:"",
      showShow:false,
      cookieName: "",
      isLogin: false,
      threeSupreme: {}
    }

    this.handleShowSearch = this.handleShowSearch.bind(this);

  }

  componentWillMount() {

// FETCH JSON

      var url = Global.getAPI('topnav');
      var self = this;
      fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: topnav");
        }
        return response.json();
      })
      .then(function(data) {

        // get the categories
        var topNavArray = [];
        var topNavBodyArray = [];
        var threeSupremeArray = [];
        var obj = {};
        var propertyNameActive = "";
        let topNavMigx = {};
        for(var propertyName in data ) {

            if( propertyName == "topMainSub" ) {

              for(var block in data[propertyName] ) {

                var array = {"left":[],"right":[]}
                // left = categories, right = promo

                if( propertyNameActive === "" ) {
                  propertyNameActive = block;
                }

                for( var subBlock in data[propertyName][block] ) {

                  if( subBlock != "title") {
                    if( subBlock.indexOf('column') != -1 ) {
                      array['left'].push(data[propertyName][block][subBlock]);
                    } else {
                      array['right'].push(data[propertyName][block][subBlock]);
                    }
                  }
                }

                topNavBodyArray[''+block] = array;
                topNavArray.push([{"property":block, "title":data[propertyName][block].title}]);
              }

            }

            if(propertyName == "threeSupreme"){
              threeSupremeArray.push([{
                "id": data[propertyName]['id'],
                "title": data[propertyName]['title'],
                "link": data[propertyName]['url'],
                "src": data[propertyName]['src']
              }]);
            }
        }
          topNavMigx = {...data.topNavMigx};
        var cookieName = "BTkPFJMohHNmRD";
        var cookie = Global.getCookie(cookieName);
        var userName = (cookie.length > 0) ? cookie.split("|")[1] : "";
        var isLogin = (cookie.length > 0) ? true : false;

        self.setState({
          topNav:data,
          topNavPages:topNavArray,
          topNavBody:topNavBodyArray,
          topNavActive:propertyNameActive,
          cookieName: cookieName,
          userName: userName,
          isLogin: isLogin,
          threeSupreme: threeSupremeArray,
          topNavMigx
        }, _ => {
          window.THREE_MAIN.nav.init();
        });

      });

// GLOBAL

      window.THREE_REACT_APP_GLOBAL.fn['Common_Nav_setTopNavActive'] = (propertyNameActive) => {

        this.setState({
          topNavActive:propertyNameActive
        });
      }

  }

/*

SEARCH

*/

  handleShowSearch() {

  }


/*

TOP

*/
  getThreeSupreme(){
    let paddingLeftStyle = window.THREE_REACT_APP_GLOBAL.language === "en" ? {paddingLeft: 0} : {};
    //3Supreme For Desktop
    let html = this.state.threeSupreme.map( ( page, index ) =>
        <li key={index} className="hidden-xs" style={{position: "relative", top: 11}}>
          <a href={page[0].link} className="navbar-body-anchor" style={paddingLeftStyle}>
            {/*<span className="navbar-label">{page[0].title}</span>*/}
            <img src={page[0].src} style={{height: 35}}/>
          </a>
        </li>
    );

    return html;
  }

  getNavBarTopLeftListHTML() {

    let html = this.state.topNavPages.map( ( page, index ) =>{
      if(page[0].title.length > 25) {
        return (
            <li key={index} className="hidden-xs" style={{width: 249, position: "relative", top: 9}}>
              <a href="javascript:void(0)" className="navbar-body-anchor" data-menu={page[0].property} style={{paddingLeft: 0}}>
                <span className="navbar-label" style={{lineHeight: 1}}>{page[0].title}</span>
              </a>
            </li>
        );
      }
      else{
        return (
            <li key={index} className="hidden-xs">
              <a href="javascript:void(0)" className="navbar-body-anchor" data-menu={page[0].property}><span
                  className="navbar-label" style={{lineHeight: 1}}>{page[0].title}</span></a>
            </li>
        );
      }
    });

    let linkhtml = this.state.topNavMigx.items.map( ( item, index ) =>
        <li key={index} className="hidden-xs">
          <a href={item.url} className="navbar-body-anchor"><span className="navbar-label">{item.headline}</span></a>
        </li>
    );

    return (
      <ul className="navbar-top-left-list navbar-top-list">
        <li className="navbar-logo-block">
          <span className="v-align-middle"></span>
          <a href={this.state.topNav.general.homeUrl}><img className="navbar-logo" src="/assets/images/nav/brandThree.png" alt="3" /></a>
        </li>
        {html}
        {this.getThreeSupreme()}
        {/* {linkhtml} */}
      </ul>
    );

  }

  //Updated to 25px today
  getThreeSupremeIcon(){
    //Get the 3Supreme Icon
    let html = this.state.threeSupreme.map( ( item, index ) =>
      <li key={index} className={item[0].id+"-wrapper"}>
        <span className="v-align-middle"></span>
        <a href={item[0].link} id={item[0].id} className="btn-image" >
          <img src={item[0].src} className="navbar-icon hidden-md visible-xs" alt={item[0].title} style={{width: 'auto',height:'25px',marginTop:'-4px'}} />
        </a>
      </li>
    );

    return html;
  }

  getNavBarTopRightListHTML() {

    var propertyNameArray = [];

    for(var propertyName in this.state.topNav.topSubNav) {
      if(propertyName != 'chat'){ //Hidden 'iChat' icon @ 20190116
        propertyNameArray.push( propertyName );
      }
    }

    var topSubNavArray = [];
    var topSubNavArrayData =  this.state.topNav.topSubNav;

    let loginHTML = '';

    for( let i = 0; i < propertyNameArray.length; i++ ) {
      if( propertyNameArray[i] == "lang" ) {

        if( window.THREE_REACT_APP_GLOBAL.language == "en" ) {
          topSubNavArrayData["lang"].href=window.lang_url_tc;
        } else {
          topSubNavArrayData["lang"].href=window.lang_url_en;
        }

      }
      if (propertyNameArray[i] !== "login") {
        topSubNavArray.push( topSubNavArrayData[propertyNameArray[i]] );
      }
      else {
        loginHTML = this.getLoginButtonHTML(topSubNavArrayData['login']);
      }
    }

    let html = topSubNavArray.map( ( item, index ) =>
        <li key={index} className={item.id+"-wrapper"}>
          <span className="v-align-middle"></span>
          <a href={item.href} id={item.id} className="btn-image" >
            <img src={item.src} className="navbar-icon" alt={item.alt} />
          </a>
        </li>
    );

    return (

      <ul className="navbar-top-right-list navbar-top-list">
        {this.getThreeSupremeIcon()}
        {html}
        {loginHTML}
        <li className="navbar-searchIcon">
          <span className="v-align-middle"></span>
          <button type="button" className="btn-image" onClick={this.handleShowSearch}>
            <span className="v-align-middle"></span>
            <img src="/assets/images/nav/search.png" className="navbar-icon" alt="" />
            <span className="navbar-label">{this.state.topNav.general.search}</span>
          </button>
        </li>
        <li className="navbar-searchIcon-xs">
          <span className="v-align-middle"></span>
          <button type="button" className="btn-image" onClick={this.handleShowSearch}><img src="/assets/images/nav/search-mobile.png" className="navbar-icon" alt="Search" /></button>
        </li>
        <li className="navbar-hamburger-xs">
          <span className="v-align-middle"></span>
          <button type="button" className="btn-image navbar-menu"><img src="/assets/images/nav/hamburger.png" className="navbar-icon" alt="Menu" /></button>
        </li>
      </ul>

    );

  }

/*

LOGIN / LOGOUT

*/
  getLoginButtonHTML(item) {
    var logoutURL = item.logoutHref + window.current_url;
    if(this.state.isLogin) {
      return (
        <li className="subnavlogin-wrapper hidden-xs">
          <span className="v-align-middle"></span>
            <a href={logoutURL} id={item.id} className="btn-image">
              <img src={item.loggedInSrc} className="navbar-icon" alt={item.logoutLabel} />
              {/* <span>{item.logoutLabel}</span> */}
              <span>{this.state.userName}</span>
            </a>
        </li>
      );
    }else{
      return (
        <li className="subnavlogin-wrapper hidden-xs">
          <span className="v-align-middle"></span>
            <a href={item.href} id={item.id} className="btn-image">
               <img src={item.src} className="navbar-icon" alt={item.alt} />
              <span>{item.label}</span>
            </a>
        </li>
      );
    }
  }

/*

BODY

*/

  getNavBarBodyPromoBlockHTML() {
    let html = this.state.topNavBody[this.state.topNavActive].left.map( (item, index) =>

        <div key={index} className="col-xs-4 nav-list-block">
          {item.ad.link !== "" ? <a href={item.ad.link} className="nav-category-promo"><img src={item.ad.src} className="img-responsive" alt={item.ad.alt} /></a> : <img src={item.ad.src} className="img-responsive" alt={item.ad.alt} />}
        </div>

    );

    return (

      <div className="row nav-category-promo-block">
        {html}
      </div>

    );

  }

  getNavBarBodyHeadingHTML() {

    let html = this.state.topNavBody[this.state.topNavActive].left.map( (item, index) =>

        <div key={index} className="col-xs-4 nav-list-block">
          {item.link && <a href={item.link}><h2>{item.title}</h2></a>}
          {!item.link && <h2>{item.title}</h2>}
        </div>

    );

    return (

      <div className="row nav-category-heading-block">
        {html}
      </div>

    );

  }

  getNavBarBodyCategoryListHTML() {

    let html = this.state.topNavBody[this.state.topNavActive].left.map( (item, index) =>

      <div key={index} className="col-xs-4 nav-list-block">
         <div className="nav-list-body">
          {this.getNavBarBodyCategoryListInnerHTML(item.items)}
         </div>
      </div>

    );

    return (
      <div className="row nav-category-list-block">
       {html}
      </div>
    );

  }

  getNavBarBodyCategoryListInnerHTML(items) {

    let html = items.map( (item, index) =>
      <li key={index}><a href={item.href}>{item.label}</a></li>
    );

    return (
     <ul className="nav-category-list nav-list">
        {html}
     </ul>
    );

  }

  getNavBarBodyCategoryButtonHTML() {

    let html = this.state.topNavBody[this.state.topNavActive].left.map( (item, index) =>

      item.link ? <div key={index} className="col-xs-4 nav-list-block"><a href={item.viewLink} className="view-all-deals">{item.viewLabel}</a></div> : <div key={index} className="col-xs-4 nav-list-block"></div>

    );

    return (
      <div className="row nav-category-view-all-block">
        {html}
      </div>
    );

  }

/*

PROMO

*/

  getNavBarPromoListHTML() {

    var listArray = [];
    var onsell = this.state.topNavBody[this.state.topNavActive].right[0];

    if( !onsell.length ) {
      return false;
    }

    let html = onsell.map( (item, index) =>
      (item.type == "list" &&
      <div key={index} className=" nav-list-block">
        <div className="nav-list-body">
          <h3>{item.title}</h3>
           {this.getNavBarPromoListInnerHTML(item.items)}
        </div>
      </div>
      )
    );

    return html;
  }

  getNavBarPromoListInnerHTML(items) {

      let html = items.map( (item, index) =>
         <li key={index}><a href={item.href}>{item.label}</a></li>
      );

      return (

        <ul className="nav-onsell-list nav-list">
          {html}
        </ul>

      );

  }

  getNavBarPromoOfferHTML() {

    var offerArray = [];
    var onsell = this.state.topNavBody[this.state.topNavActive].right[0];

    if( !onsell.length ) {
      return false;
    }

    let html = onsell.map( (item, index) =>
      (item.type == "offer" &&
        <div key={index} className=" nav-list-block">
          <ul className="nav-onsell-list nav-list">
            <li>
              <div className="nav-list-body">
               <h3>{item.title}</h3>
              </div>
              <a href={item.href}><img src={item.src} className="img-onsell img-responsive" alt={item.alt} /></a>
            </li>
          </ul>
          {item.viewMoreHref != "" && <a href={item.viewMoreHref} className="view-all-deals">{item.viewMoreLabel}</a>}
        </div>
      )
    );

    return html;

  }

  render() {

    if( Object.keys(this.state.topNav).length === 0 ) {
      return false;
    } else {

      return (
		<div className={window.xmas_theme ? "xmas react-row" : "react-row"}>
        <div id="navbar">
            <nav className="navbar-top" role="navigation">
             <div className="container">
              <div className="row">
                  <div className="navbar-top-left">
                    {this.getNavBarTopLeftListHTML()}
                  </div>
                  {/* navbar top left END */}
                  <div className="navbar-top-right">
                    {this.getNavBarTopRightListHTML()}
                  </div>
                  {/* navbar top right END */}
                </div>
             </div>
            </nav>
            <div className="navbar-body">
              <div className="container">
                <div className="row">
                  <div className="col-xs-12 col-sm-9 nav-category-block">

                    {this.getNavBarBodyPromoBlockHTML()}

                    {this.getNavBarBodyHeadingHTML()}

                    {this.getNavBarBodyCategoryListHTML()}

                    {this.getNavBarBodyCategoryButtonHTML()}

                  </div>{/* nav category block END */}

                  <div className="col-xs-12 col-sm-3 nav-onsell-block">

                    {/* add a new close button to close the main nav body */}
                    <div className="btn-close-container">
                      <a className="btn-close-nav"></a>
                    </div>

                    {this.getNavBarPromoListHTML()}

                    {this.getNavBarPromoOfferHTML()}

                  </div>{/* nav onsell block END */}


                </div>
              </div>
            </div>{/* navbar-body END */}
        {/* navbar desktop END */}
        </div>
          <NavMobile 
            topNavPages={this.state.topNavPages} 
            topNavBody={this.state.topNavBody} 
            login={this.state.topNav.topSubNav.login} 
            isLogin={this.state.isLogin} 
            userName={this.state.userName} 
            mobileNav={this.state.topNav.mobileNav} 
            threeSupreme={this.state.threeSupreme} />
          <OldSearch />
		</div>

      );
    }
  }
}

export default Nav;
